export const PRESCRIPTION_FIELDS: Record<string, string> = {
    sph_od: 'Sphere',
    sph_os: 'Sphere',
    cyl_od: 'Cylinder',
    cyl_os: 'Cylinder',
    axi_od: 'Axis',
    axi_os: 'Axis',
    add_od: 'Add',
    add_os: 'Add',
};

export const FILL_IT_ONLINE_METHOD = 1;
export const SEND_EMAIL_OR_FAX_METHOD = 3;
export const PRESCRIPTION_UPLOAD_METHOD = 4;
export const NOT_SELECTED = 0;
